<template>
  <div id="kt_header" class="header align-items-stretch">
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
      <div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show aside menu">
        <div class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="currentColor" />
              <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="currentColor" />
            </svg>
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <a href="#" class="d-lg-none">
          <img alt="Logo" src="/assets/media/logos/qomerxia-logo.png" class="h-15px" />
        </a>
      </div>
      <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
        <div class="d-flex align-items-stretch" id="kt_header_nav">
          <div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu"
               data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
               data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="end"
               data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend"
               data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                 id="#kt_header_menu" data-kt-menu="true">
              <div class="d-flex align-items-center ms-1 ms-lg-3">
                <span class="badge badge-light-primary fs-7 fw-bold">{{ $t('landlord.header.central_admin') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-stretch flex-shrink-0">
          <!-- Tickets support -->
          <div class="d-flex align-items-center ms-1 ms-lg-3">
            <div class="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative"
                 data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <i class="bi bi-headset fs-3"></i>
              <span
                v-if="openTicketsCount > 0"
                class="badge badge-circle badge-danger position-absolute notif-badge-pulse"
                style="top: 2px; right: 2px;"
              >{{ openTicketsCount }}</span>
            </div>
            <div class="menu menu-sub menu-sub-dropdown menu-column w-300px" data-kt-menu="true">
              <div class="px-5 py-3 fw-bold border-bottom">{{ $t('landlord.tickets.title') }} ({{ openTicketsCount }})</div>
              <div v-if="!recentTickets.length" class="px-5 py-4 text-gray-500 fs-7">
                {{ $t('landlord.tickets.no_results') }}
              </div>
              <router-link
                v-for="ticket in recentTickets"
                :key="ticket.id"
                :to="{ name: 'landlord-tickets', query: { open: ticket.id } }"
                class="menu-item px-3"
              >
                <span class="menu-link d-flex flex-column align-items-start px-5 py-2">
                  <span class="fw-bold">
                    {{ ticket.reference }} — {{ ticket.shop_name || '—' }}
                    <span class="badge ms-1" :class="ticket.priority === 'critical' ? 'badge-light-danger' : 'badge-light-primary'">
                      {{ $t('landlord.tickets.priority_' + ticket.priority) }}
                    </span>
                  </span>
                  <span class="text-gray-500 fs-8">{{ $t('landlord.tickets.category_' + ticket.category) }}</span>
                </span>
              </router-link>
              <div class="px-5 py-3 border-top text-center">
                <router-link :to="{ name: 'landlord-tickets' }" class="fs-7 fw-bold">
                  {{ $t('landlord.tickets.view_all') }}
                </router-link>
              </div>
            </div>
          </div>

          <!-- Language switcher -->
          <div class="d-flex align-items-center ms-1 ms-lg-3">
            <div class="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
                 data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <img class="h-20px w-20px rounded-sm" :src="currentLanguage?.img" alt="" />
            </div>
            <div class="menu menu-sub menu-sub-dropdown menu-column w-150px" data-kt-menu="true">
              <div v-for="lang in langs" :key="lang.code" class="menu-item px-3">
                <a @click.prevent="changeLang(lang)" href="#" class="menu-link d-flex px-5 active">
                  <span class="symbol symbol-20px me-4">
                    <img class="rounded-1" :src="lang.img" :alt="$t(lang.title)" />
                  </span>{{ $t(lang.title) }}
                </a>
              </div>
            </div>
          </div>

          <!-- Admin name -->
          <div class="d-flex align-items-center ms-1 ms-lg-3">
            <span class="btn btn-icon btn-sm btn-light btn-icon-muted btn-active-light btn-active-color-primary h-auto w-auto p-2">
              <i class="fa fa-user-shield me-1"></i>
              {{ adminName }}
            </span>
          </div>

          <!-- Logout -->
          <div class="d-flex align-items-center ms-1 ms-lg-3">
            <a @click.prevent="logOut" :title="$t('auth.logout')"
               class="h-auto w-auto p-3 btn btn-icon btn-sm btn-light btn-icon-muted btn-active-light btn-active-color-primary">
              <i class="fa fa-sign-out-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import landlordAxios from '@/services/landlordAxios'

export default {
    data() {
        return {
            openTicketsCount: 0,
            recentTickets: [],
            _ticketsPollInterval: null,
            langs: {
                en: {
                    img: '/assets/media/flags/united-states.svg',
                    title: 'header.language.english',
                    code: 'en'
                },
                fr: {
                    img: '/assets/media/flags/france.svg',
                    title: 'header.language.french',
                    code: 'fr'
                },
            }
        }
    },
    computed: {
        ...mapGetters('landlordAuth', { admin: 'admin' }),

        adminName() {
            return this.admin ? this.admin.fullname : ''
        },
        currentLanguage() {
            return this.langs[this.$i18n?.locale]
        },
    },
    methods: {
        ...mapActions('landlordAuth', ['logout']),

        loadOpenTickets() {
            landlordAxios.get('landlord/tickets', { params: { status: 'new', per_page: 5 } }).then((response) => {
                this.recentTickets = response.data.data
                this.openTicketsCount = response.data.meta.total
            })
        },

        changeLang(lang) {
            this.$i18n.locale = lang.code
            localStorage.setItem('locale', lang.code)
        },

        logOut() {
            Swal.fire({
                text: i18n.global.t('swal.logout'),
                icon: 'success',
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: i18n.global.t('swal.yes'),
                cancelButtonText: i18n.global.t('swal.no'),
                customClass: {
                    confirmButton: 'btn fw-bold btn-primary',
                    cancelButton: 'btn fw-bold btn-secondary'
                }
            }).then((result) => {
                if (result.value) {
                    this.logout()
                    window.toastr['success'](i18n.global.t('landlord.logout_success'))
                }
            })
        },
    },
    updated() {
        this.$nextTick(() => {
            KTMenu.init()
        })
    },
    mounted() {
        this.loadOpenTickets()
        this._ticketsPollInterval = setInterval(() => {
            this.loadOpenTickets()
        }, 30000)
    },
    unmounted() {
        if (this._ticketsPollInterval) {
            clearInterval(this._ticketsPollInterval)
        }
    },
}
</script>

<style scoped>
.notif-badge-pulse {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    font-size: 0.65rem;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    animation: notif-badge-pulse-anim 1.6s infinite;
}

@keyframes notif-badge-pulse-anim {
    0% {
        box-shadow: 0 0 0 0 rgba(241, 65, 108, 0.7);
    }
    70% {
        box-shadow: 0 0 0 7px rgba(241, 65, 108, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(241, 65, 108, 0);
    }
}
</style>
